import { MI_MULTIPLIER_SHARED_TEXTURE_KEYS } from './constants'

export const michiganKickerSharedAssetPreloader = (scene: Phaser.Scene) => {
  const prefix = `/add-ons/multiplier/michigan-kicker-shared/`

  if (!scene.textures.getTextureKeys().includes(MI_MULTIPLIER_SHARED_TEXTURE_KEYS.ATLAS)) {
    scene.load.multiatlas(
      MI_MULTIPLIER_SHARED_TEXTURE_KEYS.ATLAS,
      `${prefix}atlas/multiplier-michigan-kicker-images.json`,
      `${prefix}atlas/`,
    )
  }
}
